
// const env_name = "local"
const env_name = "live"
// const env_name = "demo"

var backurl = ""
if (env_name === "local") {
    backurl = "http://localhost:7534"
}
else {

    backurl = "https://api.ainfra.work" // mainet
    // backurl ="https://backend-opengpt.maticz.in" // testnet
    // backurl ="https://backend-nodeai.maticz.in" // testnet

}

export default backurl;